import React from "react";

const Loader = ({ className = "", style = {} }) => {
	return (
		<div className="flex justify-center items-center w-screen h-screen">
			<div className={`ap-loader ${className}`} style={style}>
				<div></div>
				<div></div>
			</div>
			<style>
				{`
				.ap-loader {
					width: 48px;
					height: 48px;
					border-radius: 50%;
					position: relative;
					animation: ap-loader-spin 1s linear infinite;
				}

				.ap-loader > div:nth-child(1) {
					position: absolute;
					width: 100%;
					height: 100%;
					border: 4px solid transparent;
					border-top-color: #b3b3b3;
					border-radius: 50%;
				}

				.ap-loader > div:nth-child(2) {
					position: absolute;
					width: 100%;
					height: 100%;
					border: 4px solid transparent;
					border-bottom-color: #b3b3b3;
					border-radius: 50%;
					transform: rotate(45deg);
				}

				@keyframes ap-loader-spin {
					0% {
						transform: rotate(0deg);
					}
					100% {
						transform: rotate(360deg);
					}
				}
			`}
			</style>
		</div>
	);
};

export default Loader;
